import script from "./CustomFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFooter.vue?vue&type=script&setup=true&lang=js"

import "./CustomFooter.vue?vue&type=style&index=0&id=6dc6413a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc6413a"]])

export default __exports__